import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ClockIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="clock" ref={ref} {...props}>
      <path d="M12,21.75A9.75,9.75,0,1,1,21.75,12,9.76,9.76,0,0,1,12,21.75Zm0-18A8.25,8.25,0,1,0,20.25,12,8.26,8.26,0,0,0,12,3.75Zm3.53,11.78a.75.75,0,0,0,0-1.06l-2.78-2.78V8a.75.75,0,0,0-1.5,0v4a.75.75,0,0,0,.22.53l3,3a.75.75,0,0,0,1.06,0Z" />
    </Icon>
  ),
) as IconWithRender;

ClockIcon.displayName = 'ClockIcon';
ClockIcon.renderIcon = (props) => <ClockIcon {...props} />;
export default ClockIcon;
